import { t } from '@/i18n'
import type { DeliveryMode } from '@/constants/mockCheckout'

/** Моки экрана статуса заказа — секции «Статус заказа / Доставка и Самовывоз». */

export interface StatusStep {
  /** Иконка кружка степпера */
  icon: string
  title: string
  subtitle: string
}

export interface OrderLine {
  id: string
  image: string
  title: string
  quantity: number
  /** Цена за штуку по меню, до скидок */
  price: number
  /** Сумма позиции до скидок и после: равны, когда скидки нет */
  fullSum: number
  sum: number
  /** Позицию отдали бесплатно — вместо суммы пишем «Бесплатно» */
  isFree: boolean
}

/*
 * Шаги строим функциями, а не константами: подписи должны меняться вместе
 * с языком, а массив на уровне модуля застыл бы на стартовом.
 */

/** Пять шагов доставки: принят → готовится → в пути → рядом → доставлен. */
const deliverySteps = (): StatusStep[] => [
  { icon: 'tick-circle', title: t('status.accepted'), subtitle: t('status.acceptedText') },
  { icon: 'refresh-circle', title: t('status.cooking'), subtitle: t('status.cookingText') },
  { icon: 'truck-fast', title: t('status.onWay'), subtitle: t('status.onWayText') },
  { icon: 'truck-time', title: t('status.near'), subtitle: t('status.nearText') },
  { icon: 'flag', title: t('status.delivered'), subtitle: t('status.deliveredText') },
]

/** Самовывоз короче: принят → готовится → можно забирать. */
const pickupSteps = (): StatusStep[] => [
  { icon: 'tick-circle', title: t('status.accepted'), subtitle: t('status.acceptedPickupText') },
  { icon: 'refresh-circle', title: t('status.cooking'), subtitle: t('status.cookingPickupText') },
  { icon: 'bag', title: t('status.ready'), subtitle: t('status.readyText') },
]

export function stepsOf(mode: DeliveryMode): StatusStep[] {
  return mode === 'pickup' ? pickupSteps() : deliverySteps()
}

export const COURIER = {
  name: 'Азиз',
  note: 'Ваш курьер • на скутере',
}

/** Минуты до готовности; в шапке и на шаге «курьер рядом». */
export const ORDER_ETA = [42, 35, 18, 5, 0]

/** Приложения для маршрута — шит «Построить маршрут». */
export const ROUTE_APPS = [
  { id: 'yandex', label: 'Яндекс Карты' },
  { id: 'google', label: 'Google Maps' },
  { id: '2gis', label: '2ГИС' },
]
